module.exports = __webpack_public_path__ + "static/img/solutionDetailPic8.22d7b10.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailPic8.jpg
// module id = rXj1
// module chunks = 1